<template>
  <vb-modal
    :value="show"
    class="login-modal"
    @cancel="close()"
    @opened="onOpen()"
  >
    <div slot="modal-header" class="modal-header">
      <h3 class="modal-title">
        Signup
      </h3>
    </div>
    <div slot="modal-body" class="modal-body">
      <div v-show="!signupDone" class="row">
        <form class="col-sm-12 col-md-10 col-md-offset-1">
          <!-- fake fields are a workaround for chrome autofill getting the wrong fields -->
          <input style="display: none;" type="text" name="email" />

          <div class="form-group">
            <div class="input-group">
              <span id="email" class="input-group-addon"
                ><i class="ion ion-email"></i
              ></span>
              <input
                v-model="email"
                type="text"
                class="form-control"
                placeholder="E-mail"
                aria-describedby="email"
                @keyup.enter="submit()"
              />
            </div>
            <p v-for="error in errors.email" class="text-danger">
              {{ error }}
            </p>
          </div>

          <div class="form-group">
            <div class="input-group">
              <span id="password" class="input-group-addon"
                ><i class="ion ion-key"></i
              ></span>
              <input
                v-model="password"
                type="password"
                class="form-control"
                placeholder="Password"
                aria-describedby="password"
                @keyup.enter="submit()"
              />
              <password :value="password" />
            </div>
            <p v-for="error in errors.password" class="text-danger">
              {{ error }}
            </p>
          </div>

          <div class="radio">
            <label>
              <input v-model="role" type="radio" :value="STARTUP" />
              I am an entrepreneur
            </label>
          </div>
          <div class="radio">
            <label>
              <input v-model="role" type="radio" :value="ORGANIZER" />
              I am an event organizer
            </label>
          </div>
        </form>
      </div>

      <div v-show="inProgress" class="text-center">
        <loader />
      </div>

      <div v-show="signupDone" class="row animated fadeInUp">
        <div class="col-sm-12">
          <p>
            Thank you for signing up. We've sent you a message with an
            activation link. Please check your mailbox.
          </p>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="modal-footer">
      <button
        v-show="!signupDone"
        type="button"
        class="btn btn-default"
        @click="close()"
      >
        Cancel
      </button>
      <button
        v-show="!signupDone"
        type="button"
        class="btn btn-primary"
        :disabled="inProgress"
        @click="submit()"
      >
        Sign up
      </button>
      <button
        v-show="signupDone"
        type="button"
        class="btn btn-primary"
        @click="close()"
      >
        OK
      </button>
    </div>
  </vb-modal>
</template>

<script>
import Auth from 'services/Auth'
import delayRequest from 'utils/delay-request'

const STARTUP = 'STARTUP'
const ORGANIZER = 'ORGANIZER'

function initData() {
  return {
    STARTUP: STARTUP,
    ORGANIZER: ORGANIZER,

    email: '',
    password: '',
    role: STARTUP,
    errors: { email: [], password: [] },
    inProgress: false,
    signupDone: false,
  }
}

export default {
  props: ['show'],
  data: () => {
    return initData()
  },
  computed: {
    hasErrors: function () {
      return this.email.length || this.password.length
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    onOpen() {
      Object.assign(this, initData())
    },
    submit() {
      const self = this

      const TIMEOUT = 1000
      console.log(' => signup!')
      self.inProgress = true
      const method = {
        [self.STARTUP]: Auth.signup.bind(Auth),
        [self.ORGANIZER]: Auth.signupOrganizer.bind(Auth),
      }[self.role]

      let request = method(self.email, self.password)
      request = delayRequest(request)

      request
        .finally(() => {
          self.inProgress = false
        })
        .then((response) => {
          console.log(' => signup successfull! response:', response)
          self.signupDone = true
          self.done()
        })
        .catch((response) => {
          console.warn(' => signup failed! response:', response)
          self.errors = response.data
          console.log(' => errors:', self.errors)
        })
    },
    done() {
      // Object.assign(this, initData())
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.login-modal {
  .modal-header {
    background-color: $blue;
    color: $white;
  }
  .modal-body {
    .input-group-addon {
      font-size: 18px;
      width: 40px;
    }
  }
}
</style>
